import { render, staticRenderFns } from "./HomePlans.vue?vue&type=template&id=bd935fa4&scoped=true&"
import script from "./HomePlans.vue?vue&type=script&lang=js&"
export * from "./HomePlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd935fa4",
  null
  
)

export default component.exports